<nz-card>

  <div *ngIf="!description?.length && !outline?.length && !targetAudience?.length && !learningObjectives?.length && !agenda?.length">
    <h3 class="no-margin-top">No information available.</h3>
  </div>

  <div *ngIf="description">
    <h3 class="no-margin-top">Course Description</h3>
    <p [innerHTML]="description | htmlBypass"></p>
  </div>

  <div *ngIf="outline">
    <h3>Course Outline</h3>
    <p [innerHTML]="outline | htmlBypass"></p>
  </div>

  <div *ngIf="targetAudience">
    <h3>Target Audience</h3>
    <p [innerHTML]="targetAudience | htmlBypass"></p>
  </div>

   <div *ngIf="learningObjectives">
     <h3>Learning Objectives</h3>
     <p [innerHTML]="learningObjectives | htmlBypass"></p>
   </div>

  <div *ngIf="agenda">
    <h3>Course Agenda</h3>
    <p [innerHTML]="agenda | htmlBypass"></p>
  </div>

</nz-card>
